import { useEffect, useState } from 'react';

import { BOAT_COLUMNS, type Boat } from '../boats';
import { supabase } from '../supabase';

// Mirrors use-tour.ts: single boat by id from the boats table.
export function useBoat(id: string | undefined) {
  const [boat, setBoat] = useState<Boat | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    supabase
      .from('boats')
      .select(BOAT_COLUMNS)
      .eq('id', id)
      .maybeSingle()
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) {
          setError(error.message);
          setBoat(null);
        } else {
          setBoat((data ?? null) as Boat | null);
        }
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { boat, loading, error };
}
